













import Vue from "vue";

export default Vue.extend({
  name: "ScollTopButton",
  props: {
    mobileOnly: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      isBackToTopVisible: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.scrollListener);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.scrollListener);
  },
  methods: {
    scrollListener: function () {
      const supportPageOffset = window.pageXOffset !== undefined;
      const isCSS1Compat = (document.compatMode || "") === "CSS1Compat";

      const scrollTop = supportPageOffset
        ? window.pageYOffset
        : isCSS1Compat
        ? document.documentElement.scrollTop
        : document.body.scrollTop;

      this.isBackToTopVisible = scrollTop > 250 ? true : false;
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },
});
